import React from 'react';
import { purple } from 'globals/colors';

interface FsQuestionMarkContainedIconProps {
  color?: string;
}

const FsQuestionMarkContainedIcon: React.FC<FsQuestionMarkContainedIconProps> = ({
  color = purple.BRAND,
}) => {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="28" height="28" rx="6" fill={color} />
      <path
        d="M15.46 11.5C15.46 11.7167 15.3777 11.9507 15.213 12.202C15.0483 12.4447 14.797 12.6527 14.459 12.826C14.121 12.9907 13.692 13.073 13.172 13.073H12.756L13.016 15.387H14.615L14.667 14.282C15.135 14.2127 15.5813 14.061 16.006 13.827C16.4307 13.5843 16.7773 13.268 17.046 12.878C17.3233 12.488 17.462 12.0287 17.462 11.5C17.462 11.0407 17.371 10.6377 17.189 10.291C17.007 9.94433 16.7557 9.64967 16.435 9.407C16.1143 9.15567 15.7547 8.96933 15.356 8.848C14.966 8.718 14.5587 8.653 14.134 8.653C13.6227 8.653 13.159 8.718 12.743 8.848C12.3357 8.978 11.9587 9.173 11.612 9.433C11.2653 9.68433 10.936 9.98767 10.624 10.343L11.963 11.448C12.197 11.0753 12.496 10.7937 12.86 10.603C13.224 10.4037 13.6053 10.304 14.004 10.304C14.316 10.304 14.5803 10.3517 14.797 10.447C15.0137 10.5423 15.1783 10.681 15.291 10.863C15.4037 11.0363 15.46 11.2487 15.46 11.5ZM12.587 17.233C12.587 17.519 12.704 17.7703 12.938 17.987C13.1807 18.2037 13.4753 18.312 13.822 18.312C14.1773 18.312 14.4677 18.2037 14.693 17.987C14.927 17.7703 15.044 17.519 15.044 17.233C15.044 16.947 14.927 16.6957 14.693 16.479C14.4677 16.2623 14.1773 16.154 13.822 16.154C13.4753 16.154 13.1807 16.2623 12.938 16.479C12.704 16.6957 12.587 16.947 12.587 17.233Z"
        fill="white"
      />
    </svg>
  );
};

export default FsQuestionMarkContainedIcon;
